<template>
  <!-- <div v-if="cloaked" class="row">
    <div style="margin: 300px auto; width: 145px">
      <img src="@/assets/loading.gif" />
    </div>
  </div> -->
  <!-- <div v-else>-->
  <div id="bootstrap-overrides">
    <navbar :appconfig="appconfig"></navbar>
    <div v-cloak>
      <router-view />
    </div>
    <footer-panel></footer-panel>
  </div>
</template>

<script>
import FooterPanel from '@/components/app/Footer';
import Navbar from '@/components/app/Navbar';
import { AppConfig } from '@/config/config';
import { mapGetters } from 'vuex';


export default {
  components: {
    Navbar,
    FooterPanel,
  },
  computed: {
    ...mapGetters(['cloaked', 'current_user', 'isAuthenticated']),
  },
  data() {
    return {
      backdropStyle:
        'background: url("/images/login-backdrop.jpg") no-repeat center center fixed; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;',
      appconfig: {
        title: AppConfig.title,
      },
    };
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        if (this.$route.fullPath !== '/cleartoken') {
          if (this.current_user) {
            // const matchingRoute = this.$route.fullPath.match(
            //   /^(\/slack\/|\/reports\/|\/companies\)/
            // );
            const matchingRoute = this.$route.fullPath.match(
              /^(\/slack\/|\/reports\/|\/companies\/)/,
            );
            // console.log('matchingRoute');
            // console.dir(matchingRoute);
            if (matchingRoute === null || matchingRoute.length < 1) {
              this.$router.push('/reports/create');
            }
          }
        }
      }
    },
  },
  beforeCreate() {
    // Nuclear bomb style clear down of access tokens and other data
    // Should be a one shot deal but if its needed again
    // just add another token_delete entry in localStorage

    if (!localStorage.getItem('token_delete_20240507')) {
      // console.log('deleting');
      localStorage.removeItem('access_token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_type');
      localStorage.setItem('token_delete_20240507', true);
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push('/');
      }
    } else {
      // console.log('skip delete');
    }
  },
};
</script>

<style></style>
